import { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { startJob, ensureKnown } from '../../store/knownDataSlice';
import { useNavigate } from "react-router-dom";
import QueryDetails from '../parts/QueryDetails';



function AcceptedQueryView(props) {
    const id = useParams()["id"].toUpperCase();
    const dispatch = useDispatch();
    const data = useSelector((state) => state.knownData[id]);

    useEffect(() => {
        dispatch(ensureKnown({ id }));
    }, []);



    if(!data) return;

    return (
        <div className="column g32 p32 screen center-cross">

            <div className="column g32" style={{ maxWidth: '100%' }}>

                <div className="column g8">
                    <div className="row g16 center-cross">
                        <h1>Kinnitatud pakkumine</h1>
                        <p>(ootab juhti ja bussi)</p>
                    </div>
                    <h2>{JSON.parse(data["query_route"]).map(route => route["city_name"]).join(" - ")}</h2>
                </div>

                <QueryDetails id={id} />

            </div>

        </div>
    );
};

export default AcceptedQueryView;